import type { DatabaseEngineId } from '@/core/engines';
import type { SqlSnippetTemplate } from './sqlSnippetTemplateTypes';
import { getBuiltInSqlSnippetTemplatesDml } from './builtInSqlSnippetTemplatesDml';
import { getBuiltInSqlSnippetTemplatesDdl } from './builtInSqlSnippetTemplatesDdl';
import { getBuiltInSqlSnippetTemplatesUtility } from './builtInSqlSnippetTemplatesUtility';
import { getBuiltInSqlSnippetTemplatesPlsql } from './builtInSqlSnippetTemplatesPlsql';

export function getBuiltInSqlSnippetTemplates(engineId: DatabaseEngineId): readonly SqlSnippetTemplate[] {
  return [
    ...getBuiltInSqlSnippetTemplatesDml(engineId),
    ...getBuiltInSqlSnippetTemplatesDdl(engineId),
    ...getBuiltInSqlSnippetTemplatesUtility(engineId),
    ...(engineId === 'oracle' ? getBuiltInSqlSnippetTemplatesPlsql() : []),
  ] as const;
}
